import { render, staticRenderFns } from "./MlNotice.vue?vue&type=template&id=97e0056e&scoped=true&"
import script from "./MlNotice.vue?vue&type=script&lang=js&"
export * from "./MlNotice.vue?vue&type=script&lang=js&"
import style0 from "./MlNotice.vue?vue&type=style&index=0&id=97e0056e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e0056e",
  null
  
)

export default component.exports